import { componentsMap } from "../../componentsMap";
import { ActionProps } from "../../ActionsMenu";

type ModalActionProps = {
    label: string;
    props: {
        [key: string]: string | number
    };
    populateModal: (data) => void;
}

/**
 * actions menu modal item
 */
const ModalAction = (actionProps: ModalActionProps) => {

    const {label, props, populateModal} = actionProps;

    const Component = componentsMap[props.componentName];
    const {componentName, ...componentProps} = props;

    return <Component {...componentProps} label={label} populateModal={populateModal} />;
}

export default ModalAction;
